import * as React from "react";
import PersonalDetailsForm from "./registration/PersonalDetailsForm";
import InputState from "./commons/model/form/InputState";
import Field from "./commons/model/form/Field";
import sfetch from "./commons/utils/super-fetch";
import { LegalConsent } from "./legal/LegalResource";
import { getPayload } from "./commons/utils/form-utils";
import { createRoot } from "react-dom/client";

interface GenericRegistrationFormProps {
  consumeEndpoint: string;
  successRedirectUrl: string;
  fields?: Field[];
  legalConsent?: LegalConsent;
}

interface GenericRegistrationFormState {
  errorMsg?: string;
}

export default class GenericRegistrationForm extends React.Component<
  GenericRegistrationFormProps,
  GenericRegistrationFormState
> {
  constructor(props: GenericRegistrationFormProps) {
    super(props);
    this.state = {};
    this.submit = this.submit.bind(this);
    this.onLegalDocumentsLoadError = this.onLegalDocumentsLoadError.bind(this);
  }

  render() {
    if (this.props.legalConsent) {
      this.props.legalConsent.onError = this.onLegalDocumentsLoadError;
    }
    return (
      <PersonalDetailsForm
        submitLabel={i18n["Form.GenericRegistration.Submit"]}
        onSubmitSucceeded={this.submit}
        errorMsg={this.state.errorMsg}
        fields={this.props.fields}
        legalConsent={this.props.legalConsent}
      />
    );
  }

  private submit(payload: any, form: { [key: string]: InputState }): Promise<any> {
    const userConsent = this.props.legalConsent ? getPayload(form, ["legalDocuments"]) : {};
    const request = Object.assign({}, payload["account"], { userConsent });
    return sfetch(this.props.consumeEndpoint, {
      method: "POST",
      body: JSON.stringify(request),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(() => {
        document.location.href = this.props.successRedirectUrl;
      })
      .catch((response) => {
        if (response.status == 400) {
          this.setState({
            errorMsg: i18n["Form.GenericRegistration.Error.BadRequest"],
          });
        } else if (response.status == 409) {
          response.json().then((json) => {
            if (json["status"] == "ERROR_EMAIL_MISMATCH") {
              form["email"].status.setError(
                i18n["Form.GenericRegistration.Error.EmailDifferentFromInvitation"]
              );
            } else if (json["status"] == "ERROR_EXISTING_EMAIL") {
              form["status"].status.setError(
                i18n["Form.GenericRegistration.Error.EmailAlreadyInUse"]
              );
            }
          });
        } else {
          this.setState({ errorMsg: i18n["Global.TechnicalError"] });
        }
        throw response;
      });
  }

  private onLegalDocumentsLoadError() {
    this.setState({ errorMsg: i18n["Legal.Consent.Error"] });
  }

  static loadComponent(elementId: string, props: GenericRegistrationFormProps) {
    const container = document.getElementById(elementId);
    const root = createRoot(container!);
    root.render(<GenericRegistrationForm {...props} />);
  }
}
